module.exports = __webpack_public_path__ + "assets/img/printer.17c45d4869142f0a53e503d3d40b0d95.svg";